module.exports = __webpack_public_path__ + "static/media/food4.99dbcb02.JPG";